import { createContext } from 'react';
import type { StoreApi } from 'zustand/vanilla';
import type { EditAreaDraftState } from './edit-area-draft-types';

export const EditAreaDraftContext = createContext<StoreApi<EditAreaDraftState> | null>(null);
